import * as React from "react";
import { Text } from "@uikit";
import { Hotel_Facilities } from "@kalabo/golfsavers-common";

import BarLounge_Icon from "@images/icons/hotel/bar-lounge.svg";
import Breakfast_Icon from "@images/icons/hotel/breakfast-buffet.svg";
import BusinessCentre_Icon from "@images/icons/hotel/business-centre.svg";
import FitnessCentre_Icon from "@images/icons/hotel/fitness-centre.svg";
import GolfCourse_Icon from "@images/icons/hotel/golf-course.svg";
import KidsClub_Icon from "@images/icons/hotel/kids-club.svg";
import NonSmokingRooms_Icon from "@images/icons/hotel/non-smoking-rooms.svg";
import PetsAllowed_Icon from "@images/icons/hotel/pets-allowed.svg";
import Restaurant_Icon from "@images/icons/hotel/restaurant.svg";
import RoomService_Icon from "@images/icons/hotel/room-service.svg";
import Spa_Icon from "@images/icons/hotel/spa.svg";
import SwimmingPool_Icon from "@images/icons/hotel/swimming-pool.svg";
import TennisCourts_Icon from "@images/icons/hotel/tennis-courts.svg";
import Wifi_Icon from "@images/icons/hotel/wifi.svg";

interface IProps {
  facilities: Hotel_Facilities;
}

const HotelFacilities = ({ facilities }: IProps) => {
  if (!facilities) return null;
  let hotel_facilities = () => {
    return [
      {
        available: facilities.outdoor_pool === "yes",
        hidden: facilities.outdoor_pool === "hidden",
        text: "Outdoor Pool",
        icon: <SwimmingPool_Icon />,
      },
      {
        available: facilities.indoor_pool === "yes",
        hidden: facilities.indoor_pool === "hidden",
        text: "Indoor Pool",
        icon: <SwimmingPool_Icon />,
      },
      {
        available: facilities.restaurant === "yes",
        hidden: facilities.restaurant === "hidden",
        text: "Restaurant",
        icon: <Restaurant_Icon />,
      },
      {
        available: facilities.bar_lounge === "yes",
        hidden: facilities.bar_lounge === "hidden",
        text: "Bar/Lounge",
        icon: <BarLounge_Icon />,
      },
      {
        available: facilities.breakfast_buffet === "yes",
        hidden: facilities.breakfast_buffet === "hidden",
        text: "Breakfast Buffet",
        icon: <Breakfast_Icon />,
      },
      {
        available: facilities.room_service === "yes",
        hidden: facilities.room_service === "hidden",
        text: "Room Service",
        icon: <RoomService_Icon />,
      },
      {
        available: facilities.onsite_golf === "yes",
        hidden: facilities.onsite_golf === "hidden",
        text: "Onsite Golf Course",
        icon: <GolfCourse_Icon />,
      },
      {
        available: facilities.tennis_courts === "yes",
        hidden: facilities.tennis_courts === "hidden",
        text: "Tennis Courts",
        icon: <TennisCourts_Icon />,
      },
      {
        available: facilities.spa === "yes",
        hidden: facilities.spa === "hidden",
        text: "Spa & Massage",
        icon: <Spa_Icon />,
      },
      {
        available: facilities.fitness_center === "yes",
        hidden: facilities.fitness_center === "hidden",
        text: "Fitness Centre",
        icon: <FitnessCentre_Icon />,
      },
      {
        available: facilities.business_center === "yes",
        hidden: facilities.business_center === "hidden",
        text: "Business Centre",
        icon: <BusinessCentre_Icon />,
      },
      {
        available: facilities.kids_club === "yes",
        hidden: facilities.kids_club === "hidden",
        text: "Kids Club",
        icon: <KidsClub_Icon />,
      },
      {
        available: facilities.free_wifi === "yes",
        hidden: facilities.free_wifi === "hidden",
        text: "Free Wi-Fi",
        icon: <Wifi_Icon />,
      },
      {
        available: facilities.non_smoking_rooms === "yes",
        hidden: facilities.non_smoking_rooms === "hidden",
        text: "Non-Smoking Rooms",
        icon: <NonSmokingRooms_Icon />,
      },
      {
        available: facilities.pets_allowed === "yes",
        hidden: facilities.pets_allowed === "hidden",
        text: "Pets Allowed",
        icon: <PetsAllowed_Icon />,
      },
    ];
  };
  return (
    <div className="my-10 border-t pt-10  border-grey3 ">
      <Text
        element="h2"
        size={21}
        leading={1.3}
        weight="semibold"
        className="mb-[20px]"
        color="black90"
      >
        Hotel Amenities
      </Text>
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-2 gap-4">
        {hotel_facilities().map((facility, index) => {
          if (facility.hidden) return null;
          return (
            <div key={index}>
              <Amenity
                available={facility.available}
                text={facility.text}
                icon={facility.icon}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

interface IDataProps {
  text: string;
  available: boolean;
  icon?: any;
}

const Amenity = ({ available, text, icon }: IDataProps) => {
  return (
    <div
      className={`mb-[10px] gap-2 flex flex-row items-start  ${
        !available && "opacity-50"
      }`}
    >
      {icon}
      <Text
        size={15}
        leading={1.3}
        className={`mt-[1px] mb-0 ${!available && " line-through"}`}
        color={`black90`}
      >
        {text}
      </Text>
    </div>
  );
};

export default HotelFacilities;
